<div class="filter-loading">
  @for (fakeFilter of [1,2,3,4,5,6]; track fakeFilter) {
    <div class="filter-loading__content">
      <div class="filter-loading__header">
      </div>
      @for (fakeFilterItem of [1,2,3,4,5]; track fakeFilterItem) {
        <div class="filter-loading__body">
          <div class="filter-loading__checkbox">
          </div>
          <div class="filter-loading__label">
          </div>
        </div>
      }
    </div>
  }
</div>
